import { Theme } from '@mui/material';
import { LiabilityStatus } from '../../../api/collectionLiabilitiesApi';

export const STATUS_LABEL_KEYS: Record<LiabilityStatus, string> = {
  PAID: 'collections.statusPaid',
  PENDING: 'collections.statusPending',
  EXPIRED: 'collections.statusExpired',
  CANCELLED: 'collections.statusCancelled',
};

export function getStatusColors(theme: Theme, status: LiabilityStatus): { bg: string; color: string } {
  switch (status) {
    case 'PAID':
      return { bg: theme.app.accentSurface, color: theme.app.accent };
    case 'PENDING':
      return { bg: theme.app.destructiveSurface, color: theme.app.destructive };
    default:
      return { bg: theme.app.secondary, color: theme.app.mutedForeground };
  }
}
